var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 11.5C17 11.224 16.776 11 16.5 11H12.5C12.224 11 12 11.224 12 11.5V23.5C12 23.776 12.224 24 12.5 24H16.5C16.776 24 17 23.776 17 23.5V11.5ZM5 14.5C5 14.224 4.776 14 4.5 14H0.5C0.224 14 0 14.224 0 14.5V23.5C0 23.776 0.224 24 0.5 24H4.5C4.776 24 5 23.776 5 23.5V14.5ZM11 8.5C11 8.224 10.776 8 10.5 8H6.5C6.224 8 6 8.224 6 8.5V23.5C6 23.776 6.224 24 6.5 24H10.5C10.776 24 11 23.776 11 23.5V8.5ZM23 9C23 8.724 22.776 8.5 22.5 8.5H18.5C18.224 8.5 18 8.724 18 9V23.5C18 23.776 18.224 24 18.5 24H22.5C22.776 24 23 23.776 23 23.5V9ZM19.293 1L14.401 5.892L8.724 3.053C8.531 2.957 8.299 2.994 8.146 3.146L2.146 9.146C1.951 9.342 1.951 9.658 2.146 9.854C2.342 10.049 2.658 10.049 2.854 9.854L8.599 4.108L14.276 6.947C14.469 7.043 14.701 7.006 14.854 6.854L20 1.707V4C20 4.276 20.224 4.5 20.5 4.5C20.776 4.5 21 4.276 21 4V0.5C21 0.224 20.776 0 20.5 0H17C16.724 0 16.5 0.224 16.5 0.5C16.5 0.776 16.724 1 17 1H19.293Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.74d5705a767f1ad88716bd992c3dd5d3.svg";
export { ForwardRef as ReactComponent };